{
  "documentOrder": ["til"],
  "termsPurchase": {
    "uplift": {
      "terms": "<div><span>J'ai lu, compris et accepté électroniquement le </span><i>Contrat de prêt (et la Déclaration de divulgation y figurant)</i>{{docName}}. En cliquant sur <span>\"{{btnLabel}}\"</span>, je reconnais que j'ai eu la possibilité d'accepter ou de refuser le contrat de prêt et de corriger les erreurs. <strong>Je comprends que continuer aura une incidence sur ma cote de crédit.</strong></span></div>"
    },
    "flexpay": {
      "terms": "<div><span>J'ai lu, compris et accepté électroniquement le </span><i>Contrat de prêt (et la Déclaration de divulgation y figurant)</i>{{docName}}. En cliquant sur <span>\"{{btnLabel}}\"</span>, je reconnais que j'ai eu la possibilité d'accepter ou de refuser le contrat de prêt et de corriger les erreurs. <strong>Je comprends que continuer aura une incidence sur ma cote de crédit.</strong> Je reconnais que j'ai eu la possibilité expresse d'accepter ou de refuser le Contrat de prêt et de corriger les erreurs.</span></div>"
    }
  },
  "docName": {
    "ach": "<span> et <i>l’Entente sur les débits préautorisés</i></span>",
    "dcd": "<span> et <i>l’Entente sur les Conditions de paiement</i></span>",
    "default": ""
  },
  "submit": "J'accepte et je continue"
}
